module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"siteTitle":"Survey Evaluation"},"de":{"siteTitle":"Umfragen"},"fr":{"siteTitle":"Evaluation du sondage"},"it":{"siteTitle":"Valutazione del sondaggio"}}')
  delete Component.options._Ctor
}
